// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (min-width:1200px){html{font-size:14px!important;min-width:1200px;overflow-x:auto;height:100vh}body{font-size:1rem}}@media screen and (min-width:700px) and (max-width:1200px){html{font-size:16px!important}}@media screen and (min-width:400px) and (max-width:700px){html{font-size:12px!important}.chunk-box{width:33%!important}}@media screen and (max-width:400px){html{font-size:12px!important}.chunk-box{width:50%!important}}", ""]);
// Exports
module.exports = exports;
